import React, { useMemo } from 'react';
import { Box } from '@common-fe/common-fe';

import InfoBlock from '@/components/elements/InfoBlock';
import { CronFrequency } from '@/utils/handlers/useCronBuilder';

interface Props {
  value: CronFrequency;
}

const FREQUENCY_OPTIONS = [
  {
    key: CronFrequency.Weekly,
    value: 'week',
  },
  {
    key: CronFrequency.Monthly,
    value: 'month',
  },
  {
    key: CronFrequency.Quarterly,
    value: 'quarter',
  },
  {
    key: CronFrequency.Yearly,
    value: 'year',
  },
];
const AffectedBanner: React.FC<Props> = ({ value }) => {
  const currentTitle = useMemo(() => {
    const foundItem = FREQUENCY_OPTIONS.find((item) => item.key === value);
    if (foundItem) {
      return foundItem.value;
    }
    return null;
  }, [value]);
  if (!currentTitle) {
    return null;
  }
  return (
    <Box margin={{ top: 'spacing24' }}>
      <InfoBlock
        title={`Report will be generated for the previous ${currentTitle}, based on the Frequency parameter.`}
      />
    </Box>
  );
};

export default AffectedBanner;
